import { render } from "./MarqueeWrapper.vue?vue&type=template&id=0cfbf6ec&scoped=true"
import script from "./MarqueeWrapper.vue?vue&type=script&lang=js"
export * from "./MarqueeWrapper.vue?vue&type=script&lang=js"

import "./MarqueeWrapper.vue?vue&type=style&index=0&id=0cfbf6ec&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cfbf6ec"]])

export default __exports__